<template>
  <ais-infinite-hits v-bind="$attrs" :stack="true">
    <template v-slot="{ items, refineNext, isLastPage, sendEvent }">
      <slot
        name="item"
        v-for="(item, index) in items"
        v-bind="{ item, index, sendEvent }"
      />
      <slo-infinite-loader
        @refineNext="refineNext"
        :disabled="isLastPage"
        v-bind="loaderProps"
        v-if="items.length > 0 && !isLastPage"
      >
        <slot name="loader"></slot>
      </slo-infinite-loader>
      <div class="no-results" v-if="items.length === 0">
        <slot name="no-results">
          <span v-html="noResultsMessage" />
        </slot>
      </div>
    </template>
  </ais-infinite-hits>
</template>

<script>
import t from '../main/i18n';
import SloLoader from '../../lib/components/SloLoader.vue';
import SloInfiniteLoader from './SloInfiniteLoader.vue';

export default {
  props: {
    noResultsMessage: {type: String, default: 'No results' | t},
    loaderProps: {type: Object, default: () => ({})}
  },
  components: {
    SloLoader,
    SloInfiniteLoader
  },
  name: 'SloInfiniteHits'
};
</script>
